import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BillableItemEntity } from 'src/app/models/entities/project.entity';
import { TimeSheetEntity } from 'src/app/models/entities/timesheet.entity';
import { TimesheetEditComponent } from 'src/app/components/timesheet/timesheet.component';

@Component({
    selector: 'app-timesheet-edit-modal',
    templateUrl: './edit.component.html',
    styleUrls: ['./edit.component.scss'],
    standalone: false
})
export class EditComponent implements OnInit {

  @ViewChild('timesheetEdit') timesheetEdit!: TimesheetEditComponent;

  public item: TimeSheetEntity | undefined;
  public calendarIdsForDay: string[] | undefined;
  public selectedDate: number | undefined;
  public headerDate: Date = new Date();
 
  constructor(
    public dialogRef: MatDialogRef<EditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  
  ) {
    // auth.useEmulator('http://localhost:9099');
  }
  ngOnInit(): void {

    if(this.data){

      this.item = this.data.item;
      this.calendarIdsForDay = this.data.calendarIdsForDay;
      this.selectedDate = this.data.selectedDate;
    }

    // Initialize header date
    if (this.selectedDate) {
      this.headerDate = new Date(this.selectedDate);
    } else if (this.item?.date) {
      this.headerDate = new Date(this.item.date);
    }

    this.dialogRef.afterClosed().subscribe((result) => {
      this.item = undefined;
    }
    );
  }

  public scroll(event: any){

    //this.dialogRef._containerInstance['_elementRef'].nativeElement.scrollTop =0
    // const containerElement = this.dialogRef._containerInstance._config.viewContainerRef?.element.nativeElement;;
    // containerElement.scrollTop = 0;
  }

  public onNoClick(): void {
    this.dialogRef.close();
  }

  public onCalendarEventSelected(event: boolean) {
    // Do nothing, just prevent the automatic save
  }

  public getDisplayDate(): Date {
    return this.headerDate;
  }

  public onDateChanged(): void {
    // Update the child component's date when the header datepicker changes
    if (this.timesheetEdit && this.headerDate) {
      this.timesheetEdit.timeSheetForm?.get('date')?.setValue(this.headerDate);
    }
  }
}
